import { LitElement, html, css } from 'lit'

/**
 * Componente de placeholder animado (skeleton/shimmer)
 * Exibe um bloco com animação shimmer enquanto dados estão sendo carregados.
 * Mantém as dimensões do elemento substituído para evitar layout shift.
 *
 * @element skeleton-placeholder
 *
 * @property {String} width - Largura CSS do placeholder (default: '100%')
 * @property {String} height - Altura CSS do placeholder (default: '1.5rem')
 * @property {String} borderRadius - Border-radius CSS do placeholder (default: '4px')
 * @property {String} name - Nome do campo para atributo data-cy (ex: 'saldo-total-valor' → data-cy="skeleton-saldo-total-valor")
 *
 * @example
 * <skeleton-placeholder
 *   width="120px"
 *   height="2rem"
 *   borderRadius="8px"
 *   name="saldo-total-valor">
 * </skeleton-placeholder>
 */
class SkeletonPlaceholder extends LitElement {
  static properties = {
    width: { type: String },
    height: { type: String },
    borderRadius: { type: String },
    name: { type: String }
  }

  static styles = css`
    :host {
      display: block;
    }

    .skeleton {
      background: var(--bg-surface-secondary, #1D2740);
      background-image: linear-gradient(
        90deg,
        var(--bg-surface-secondary, #1D2740) 0%,
        var(--bg-surface, #151C30) 50%,
        var(--bg-surface-secondary, #1D2740) 100%
      );
      background-size: 200% 100%;
      animation: shimmer 1.5s infinite linear;
    }

    @keyframes shimmer {
      0% {
        background-position: 200% 0;
      }
      100% {
        background-position: -200% 0;
      }
    }
  `

  constructor () {
    super()
    this.width = '100%'
    this.height = '1.5rem'
    this.borderRadius = '4px'
    this.name = ''
  }

  render () {
    return html`
      <div
        class="skeleton"
        data-cy="${this.name ? `skeleton-${this.name}` : ''}"
        style="width: ${this.width}; height: ${this.height}; border-radius: ${this.borderRadius};"
      ></div>
    `
  }
}

customElements.define('skeleton-placeholder', SkeletonPlaceholder)
